<template>
  <div class="main-body">

    <div class="header">摄像头</div>

    <div class="out">
      <div class="search2">

        <el-button type="primary" size="mini" plain @click.native="openAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input placeholder="输入老人姓名" size="mini" v-model="name" clearable style="margin-right:10px;width:120px"></el-input>
          <el-input placeholder="输入手机号" size="mini" v-model="phone" clearable style="margin-right:10px;width:140px"></el-input>
          <el-input placeholder="输入身份证号" size="mini" v-model="idCard" clearable style="margin-right:10px;width:180px"></el-input>
          <el-input placeholder="输入SN号" size="mini" v-model="sn" clearable style="margin-right:10px;width:120px"></el-input>


          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px;line-height: 20px;"></elSelectTree>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户姓名"></el-table-column>

        <el-table-column prop="phone" label="手机号" :formatter="getPhoneStr"></el-table-column>

        <el-table-column prop="sn" label="序列号（SN）" width="120"></el-table-column>
        <el-table-column prop="yzm" label="验证码"></el-table-column>
        <el-table-column prop="tdh" label="通道号"></el-table-column>

        <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter" width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">

            <el-button size="mini" type="text" @click="viewCamera(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" type="text" @click="viewCamera3(scope.$index, scope.row)">回放</el-button>

            <!--            <el-button size="mini"  @click="viewCameraPlus(scope.$index, scope.row)">对讲</el-button>-->
            <!--            <el-button size="mini"  @click="viewCameraPlusBack(scope.$index, scope.row)">回放</el-button>-->


            <el-button size="mini" type="text" @click="formatSD(scope.$index, scope.row)">SD卡格式化</el-button>
            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showAdd" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>

    <ViewCamera ref="myViewCamera" v-show="showCamera" v-on:closeCamera="closeCamera"></ViewCamera>
    <ViewCamera3 ref="myViewCamera3" v-show="showCamera3" v-on:closeCamera="showCamera3=false"></ViewCamera3>

    <ViewCameraPlus ref="myViewCameraPlus" v-show="showCameraPlus" v-on:closeCameraPlus="closeCameraPlus"></ViewCameraPlus>
    <ViewCameraPlusBack ref="myViewCameraPlusBack" v-show="showCameraPlusBack" v-on:closeCameraPlusBack="closeCameraPlusBack"></ViewCameraPlusBack>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>格式化进行中({{formatRate}})...</span>
      </div>
    </div>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "../Comm/AddDisable"

import ViewCamera from "../Comm/ViewCamera2";
import ViewCameraPlus from "../Comm/ViewCameraPlus";
import ViewCameraPlusBack from "../Comm/ViewCameraPlusBack";

import ViewCamera3 from "../Comm/ViewCamera3";

import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showModal:false,

      showAdd:false,
      showCamera:false,
      showCamera3:false,
      showCameraPlus:false,
      showCameraPlusBack:false,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:"",
      phone: "",
      sn: "",
      idCard:'',


      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',

      formatRate:0,

    };
  },
  components: {Add,ViewCamera,elSelectTree,ViewCameraPlus,ViewCameraPlusBack,ViewCamera3},
  created() {
    this.getZone();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    openAdd: function () {
      this.showAdd = !this.showAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showAdd = !this.showAdd;
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },


    viewCamera(index,row){
      this.$refs.myViewCamera.init(row.sn,row.deviceCameraCode);
      this.showCamera =!this.showCamera;
    },
    viewCamera3(index,row){
      this.$refs.myViewCamera3.init(row.sn,row.deviceCameraCode);
      this.showCamera3 =!this.showCamera3;
    },

    viewCameraPlus(index,row){
      this.$refs.myViewCameraPlus.init3(row.sn,row.deviceCameraCode,row.yzm,row.tdh);
      this.showCameraPlus =!this.showCameraPlus;
    },
    viewCameraPlusBack(index,row){
      this.$refs.myViewCameraPlusBack.init3(row.sn,row.deviceCameraCode,row.yzm,row.tdh);
      this.showCameraPlusBack =!this.showCameraPlusBack;
    },



    formatSD(index,row){

      let that = this;

      this.$confirm("您确定要格式化SD卡吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {



        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceCamera/Format",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceCameraCode: row.deviceCameraCode,
          },
        }).then((response) => {
          //console.log(response);

          if (response.data.data.code == 200) {
            this.$message({message: "格式化已启动", type: "success",});

            this.showModal = true;
            setTimeout(function (){that.getFormatRate(row);},5000);

          } else {
            this.$message.error(response.data.data.msg);
          }


        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });

    },

    getFormatRate(row){

      let that = this;

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/FormatRate",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceCameraCode: row.deviceCameraCode,
        },
      }).then((response) => {
        //console.log(response);

        if(response.data.data.code== 200){
          let data = response.data.data.data;
          let formattingRate = data.formattingRate;
          //console.log(formattingRate);

          this.formatRate = formattingRate;

          if(formattingRate<100){
            setTimeout(function (){that.getFormatRate(row);},5000);
          }else{
            this.$message({type: "info", message: "格式化完成",});
            this.showModal = false;
            this.openRecord(row);
          }

        }


      }).catch(function (error) {
        console.log(error);
      });


    },

    openRecord(row){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/OpenRecord",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceCameraCode: row.deviceCameraCode,
        },
      }).then((response) => {
        console.log(response);

      }).catch(function (error) {
        console.log(error);
      });

    },





    closeCamera(){
      this.showCamera =!this.showCamera;
    },
    closeCameraPlus(){
      this.showCameraPlus =!this.showCameraPlus;
    },
    closeCameraPlusBack(){
      this.showCameraPlusBack =!this.showCameraPlusBack;
    },


    getZoneValue(val) {
      this.zoneCode = val
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/PageByZoneCodeClassName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          phone: this.phone,
          sn: this.sn,
          name:this.name,
          idCard:this.idCard,
          zoneCode:this.zoneCode,
          elderlyClassName:'残疾人',

        },
      }).then((response) => {
        //console.log(response.data.data);

        this.tableLoading=false
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceCamera/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceCameraCode: row.deviceCameraCode,
          },
        }).then((response) => {
          //console.log(response);

          if (response.data.error == 0) {
            this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }

        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        this.$message({type: "info", message: "已取消解绑",});
      });

    },


    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },


    getH5Url(deviceCameraCode){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DeviceCamera/GetH5Url",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceCameraCode:deviceCameraCode,
        }
      }).then((response) => {
        console.log(response.data.data);
        if (response.data.error == 0) {
          console.log(response.data.data);
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },




  },
};
</script>


<style scoped>
/deep/ .search .el-input__inner{
  height: 28px;line-height: 28px;
}
/deep/ .search .el-input__icon{
  height: 28px;line-height: 28px;
}
</style>

<style   lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;
}

.label{
  padding: 5px 0px;
}
</style>
